<template>
  <div class="main-container">
    <div class="main-container__icon">
      <div
          v-if="infoType === 'loading'"
          class="main-container__icon__loader"></div>
      <img
          v-else
          :src="icons.checkGreen"
          class="main-container__icon__success-icon">
    </div>
    <div
        class="main-container__message">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProcessingInfo",
  props: {
    message: {
      type: String,
      required: true,
      default: () => {
        return false;
      },
    },
    infoType: {
      type: String,
      required: true,
      default: () => {
        return "loading";
      },
    },
  },
  data() {
    return {
      icons: {
        checkGreen: require("@/assets/icons/new-ui/customer/authorizations/shared/check_green.svg"),
      },
    };
  },
};
</script>

<style scoped>
.main-container {
  vertical-align: middle;
}

.main-container__icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 50px;
  height: 40px;
  text-align: center;
}

.main-container__message {
  width: 245px;
  margin: 0 auto;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #424242;

  position: relative;
  vertical-align: middle;
  display: inline-block;
}

.main-container__icon__loader {
  border: 3px solid #f6f8fa; /* Light grey */
  border-top: 3px solid #1998d5; /* Blue */
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 2s linear infinite;
  display: inline-block;
  position: relative;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.main-container__icon__success-icon {
  height: 24px;
  width: 24px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
